import { ref, readonly } from 'vue'
import api from '~/services/api'

export interface PaymentModalState {
  showConfirmModal: boolean
  showCheckPrintModal: boolean
  isCheckPrinting: boolean
  checkPrintError: string
}

export interface CheckPrintParams {
  orderData: any
  totalAmount: number
  restaurantCode: string
}

export function usePaymentModals () {
  const modalState = ref<PaymentModalState>({
    showConfirmModal: false,
    showCheckPrintModal: false,
    isCheckPrinting: true,
    checkPrintError: ''
  })

  const openConfirmModal = () => {
    modalState.value.showConfirmModal = true
  }

  const closeConfirmModal = () => {
    modalState.value.showConfirmModal = false
  }

  const openCheckPrintModal = () => {
    modalState.value.showCheckPrintModal = true
    modalState.value.isCheckPrinting = true
    modalState.value.checkPrintError = ''
  }

  const closeCheckPrintModal = () => {
    modalState.value.showCheckPrintModal = false
  }

  const setCheckPrinting = (printing: boolean) => {
    modalState.value.isCheckPrinting = printing
  }

  const setCheckPrintError = (error: string) => {
    modalState.value.checkPrintError = error
  }

  const handleCheckPrinted = () => {
    modalState.value.isCheckPrinting = false
    modalState.value.showCheckPrintModal = false
  }

  const proceedToPayment = async (callback: () => Promise<void>) => {
    modalState.value.showConfirmModal = false
    openCheckPrintModal()
    await callback()
  }

  const handlePaymentCancel = () => {
    closeConfirmModal()
  }

  const handleCheckPrintClose = (onSuccess?: () => void) => {
    closeCheckPrintModal()
    if (!modalState.value.isCheckPrinting && onSuccess) {
      onSuccess()
    }
  }

  // Запрос на печать чека
  const printCheck = async (params: CheckPrintParams): Promise<void> => {
    try {
      const { orderData, totalAmount, restaurantCode } = params

      if (!orderData) {
        throw new Error('Данные заказа не найдены')
      }

      const requestBody = {
        external_id: orderData.orders[0].order_id,
        email: 'shadow_mg222@mail.ru',
        phone: '89128060555',
        amount: totalAmount * 100,
        order_id: orderData.orders[0].id
      }

      const response = await api.post(
        `/order/check-of-intent-to-order/${restaurantCode}`,
        requestBody
      )

      // Имитация процесса печати чека
      // await new Promise(resolve => setTimeout(resolve, 6000))

      if (response.data.success === true && response.data.result === true) {
        setTimeout(() => {
          handleCheckPrinted()
        }, 6000)
      } else {
        throw new Error('Ошибка печати чека')
      }
    } catch (error: any) {
      setCheckPrintError('Не удалось распечатать чек')
      // Все равно продолжаем через 6 секунд
      setTimeout(() => {
        handleCheckPrinted()
      }, 6000)
    }
  }

  return {
    modalState: readonly(modalState),
    openConfirmModal,
    closeConfirmModal,
    openCheckPrintModal,
    closeCheckPrintModal,
    setCheckPrinting,
    setCheckPrintError,
    handleCheckPrinted,
    proceedToPayment,
    handlePaymentCancel,
    handleCheckPrintClose,
    printCheck
  }
}
